import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,dynamicUrl,DownloadFile } from './Function';
import { useDynamicLink } from './DynamicUse';
import { Row,Col,Card,Form,InputGroup,Button,Placeholder } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const NewsLetters = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dynamicLinkData = useDynamicLink(230);
    const[isLoading, setLoading] = useState(true);
    const[NewsLetters,setNewsLetters]=useState([]);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        NewsLettersList();
        // eslint-disable-next-line
    },[])
    const NewsLettersList = async (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (!keyword && year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        try 
        {
            setLoading(true);
            var keywordText = keyword || 'none';
            var startLimit = 0;        
            const { startDate, endDate } = setDateRange(year, month, 0, 0, 1);
            const callApi = global.config.API_URL + `newsLetters/list/${keywordText}/${startDate}/${endDate}/${startLimit}`;
            if(global.config.IsPrint) console.info('NewsLettersList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.n_id + "/nNewsletter")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.n_id + "/nNewsletterHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].nNewsletter = el.upp;
                        result[i].nNewsletterHi = el.upph;                            
                    });
                    setNewsLetters(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('NewsLettersList File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setNewsLetters([]);
                setLoading(false);
            }
            if( global.config.IsPrint === true ) { console.info('NewsLettersList : Result',result); }
        }
        catch (error) { console.error('NewsLettersList : Error', error.message); }
    };
    return (
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {t('Newsletters')}
            </Card.Header>
            <Card.Body>
                <Card className='mb-3'>
                    <Card.Body>
                        <Form onSubmit={NewsLettersList}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <InputGroup>
                                        <Form.Select onChange={YearChange} value={year}>
                                            <option value={0}>{t('FilterYear')}</option>
                                            {setYearList(0, 0).map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Select onChange={MonthChange} value={month}>
                                            <option value={0}>{t('FilterMonth')}</option>
                                            {setMonthList().map(({ value, label }) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                    </InputGroup>                                    
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                {isLoading ? (
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-4 g-3'>
                {[...Array(10)].map((_,index)=>(
                    <Col key={index}>
                        <Card className="bg-primary text-white text-center" data-aos="flip-up" data-aos-duration="1000">
                            <Card.Img src={global.config.uploadPath+'1131615306.png'} />
                            <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center'>
                                <Card.Title><Placeholder xs={10} /></Card.Title>
                                <Button className='btn btn-light w-50'><Placeholder xs={12} /></Button>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                ))}
                </Row>
                ) : (
                <React.Fragment>
                {NewsLetters && NewsLetters.length > 0 ? (
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-4 g-3'>
                {NewsLetters.map((n,index)=>(
                    <Col key={index}>
                        <Card className="bg-primary text-white text-center" data-aos="flip-up" data-aos-duration="1000">
                            <Card.Img src={global.config.uploadPath+'1131615306.png'} />
                            <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center'>
                                <Card.Title>{appLanguage === 'hi' ? (n.n_display_en === "1" ? n.n_name_hi || '' : n.n_name_hi || n.n_name) : n.n_name}</Card.Title>
                                <span dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,n.nNewsletter,n.nNewsletterHi)}} />
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                ))}
                </Row>
                ) : (
                    <div className='text-center lead fw-bold'>{t('NoResult')}</div>
                )}
                </React.Fragment>
                )}
                {dynamicLinkData && dynamicLinkData.map((sp,index)=>(
                    <NavLink key={index} to={dynamicUrl(sp)} className='btn btn-info mt-4' data-aos="flip-up" data-aos-duration="1000">
                        {t('Archives')}
                    </NavLink>
                ))}
            </Card.Body>
        </Card>
    );
}
export default NewsLetters;